import React from 'react'
import loadable from '@loadable/component'
import { FeatherLoader } from '@abroad/components'

const ABSwiperSlider = loadable(() => import('./ABSwiperSlider'), {
  fallback: <FeatherLoader width={60} />,
})

export { ABSwiperSlider }
